"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAENavbarSearchSection = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

require("./FAENavbarSearchSection.scss");

var _FAEText = require("../FAEText/FAEText");

var _FAEAutoComplete = require("../FAEAutoComplete/FAEAutoComplete");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// libs
// import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
// src
// import { FAESearchBar } from "../FAESearchBar/FAESearchBar";
// scss
const FAENavbarSearchSection = _ref => {
  let {
    placeholder,
    barIcon,
    expertLogo,
    expertLogoClicked,
    signInClicked,
    signUpClicked,
    isLogin,
    userCountry,
    getSearchValue = () => {},
    searchResults = [],
    getSelectedValue: _getSelectedValue = () => {},
    renderOption
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-logo-wrapper"
  }, /*#__PURE__*/_react.default.createElement("h1", null, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      cursor: "pointer"
    },
    onClick: expertLogoClicked,
    src: expertLogo,
    alt: "Expert",
    width: "auto",
    height: "auto"
  })), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    bold: true,
    style: {
      fontSize: "12px"
    },
    paragraph: true,
    primary: true
  }, userCountry)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-search-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-search"
  }, /*#__PURE__*/_react.default.createElement(_FAEAutoComplete.FAEAutoComplete, {
    type: "search",
    onChange: e => getSearchValue(e.target.value),
    primary: true,
    placeholder: placeholder,
    values: searchResults,
    shadowBoxProps: {
      className: "auto-complete-search-bar"
    },
    getSelectedValue: value => _getSelectedValue(value),
    value: {
      label: ""
    },
    renderOption: renderOption
  }))), isLogin === true ? /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-user-signed-in"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    paragraph: true,
    primary: true
  }, "Service To"), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    bold: true,
    primary: true
  }, "London")), /*#__PURE__*/_react.default.createElement(_LocationOn.default, null)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-auth"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    onClick: signInClicked,
    className: "fae--navbar-search-section-auth-item",
    primary: true
  }, "Sign In"), /*#__PURE__*/_react.default.createElement("span", {
    className: "fae--navbar-search-section-auth-divider"
  }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    onClick: signUpClicked,
    className: "fae--navbar-search-section-auth-item",
    primary: true
  }, "Sign Up"))));
};

exports.FAENavbarSearchSection = FAENavbarSearchSection;